import { ReactElement } from 'react';

import {
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from '@mui/material';
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
} from 'react-hook-form';

export type SwitchProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<MuiSwitchProps, 'checked'> & {
  ControllerProps: Omit<ControllerProps<TFieldValues, TName>, 'render'>;
};

export const Switch = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  ControllerProps,
  ...props
}: SwitchProps<TFieldValues, TName>): ReactElement => {
  return (
    <Controller
      {...ControllerProps}
      render={({ field: { onChange, ...field } }) => (
        <MuiSwitch
          {...props}
          {...field}
          onChange={(event, checked) => {
            onChange(event);
            props.onChange && props.onChange(event, checked);
          }}
          checked={field.value as boolean}
        />
      )}
    />
  );
};
